import React, { useState, useEffect } from 'react';
//import { useSearchParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom'
import { loadFlash } from './js/common.js'
import axios from 'axios'
import './common/css/App.css';
import './css/main.css';
import './css/login.css';
import './css/fonts.css';
import './css/checkbox.css';
import './common/css/errors.css';
import './common/css/buttons.css';
import $ from 'jquery';
import Amplify, { Auth, Hub } from 'aws-amplify';
import awsconfig from './aws-exports';
import fbLogo from './images/fb_logo-44.png'
import googleLogo from './images/googlen_logo-43.png'
import bgImage from './images/omaekukka.jpg'
import Header from "./components/header/Header"
import Footer from "./components/footer/Footer"
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import useFormPersist from "react-hook-form-persist";

awsconfig.oauth.redirectSignIn = `${window.location.origin}/`;
awsconfig.oauth.redirectSignOut = `${window.location.origin}/`;

//var username_email = ""
Amplify.configure(awsconfig);

const cookieStorage = {
    domain: '.ekukka.fi',
    secure: false,
    path: '/',
    expires: 7,
};
Auth.configure({ ...awsconfig, cookieStorage });


function Login(props) {
    const [username_email, setUsername_email] = useState("")
    const [user_lostpassword_email, setUser_lost_password_email] = useState("")

    useEffect(() => {
        setUsername_email(window.localStorage.getItem('new_username_email'));
    }, []);



    function backToShop() {
        props.backToShop()
    }

    const initialformState = {
        nologout: 0, relog: 0, username: '', password: '', name: '', given_name: '', family_name: '', authCode: '', formType: 'signIn', code: '', new_password: '',
        mfaUsername: '', mfaCode: '', user: null
    }
    loadFlash()
    const [formState, updateFormState] = useState(initialformState)
    useEffect(() => {
        const now = new Date().toLocaleString('fi-FI', { timeZone: 'Europe/Helsinki' });
    }, [formState]);

    //const [searchParams, setSearchParams] = useSearchParams();
    const queryParameters = new URLSearchParams(window.location.search)
    const callCustomerBackend = "https://" + window.location.hostname + "/php/controllers/Customer.php";





    const [user, updateUser] = useState(null)
    useEffect(() => {
        controlHistory()
        setAuthListener()
        if (formState.formType !== 'mfaVerification' || !formState.user) {
            checkUser();
            checkPage();
        }
        $('body').css({ 'background-image': `url(${bgImage})`, 'background-repeat': 'no-repeat', 'background-size': 'cover' });
    }, [])
    const navigate = useNavigate();
    function controlHistory() {
        window.onpopstate = function (event) {
            const now = new Date().toLocaleString('fi-FI', { timeZone: 'Europe/Helsinki' });
            let page = 'signIn';
            if (document.location.hash.substring(1) !== '') {
                page = document.location.hash.substring(1);
            }
            // Skip if already in mfaVerification with a valid user
            if (formState.formType === 'mfaVerification' && formState.user) {
                return;
            }
            updateFormState((prev) => {
                const newState = { ...prev, formType: page, user: prev.user };
                return newState;
            });
        };
    }
    async function setAuthListener() {
        Hub.listen('auth', (data) => {
            const now = new Date().toLocaleString('fi-FI', { timeZone: 'Europe/Helsinki' });
            switch (data.payload.event) {
                case 'signIn':
                    updateUser(data.payload.data);
                    // Safely access email
                    const email = data.payload.data?.attributes?.email || formState.username || '';
                    if (email) {
                        window.localStorage.setItem('new_username_email', email);
                    } else {
                        console.warn(`[${now}] [setAuthListener] Email not found in user attributes`);
                    }
                    createUser(data.payload.data.signInUserSession?.accessToken?.jwtToken);

                    if (queryParameters.get('referer') !== null && queryParameters.get('function') === 'return') {
                        props.backToShop();
                        break;
                    }
                    updateFormState((prev) => {
                        const newState = { ...prev, formType: 'signedIn', user: data.payload.data };
                        return newState;
                    });
                    if (queryParameters.get('function') !== null) {
                        switch (queryParameters.get('function')) {
                            case 'return':
                                props.backToShop();
                                break;
                            case 'info':
                                navigate('/myEkukka' + props.urlParams + '&ref=shop');
                                break;
                            default:
                                window.location.href = 'https://' + window.location.hostname + '/profile' + props.urlParams;
                        }
                    } else {
                        window.location.href = 'https://' + window.location.hostname + '/profile' + props.urlParams;
                    }
                    break;
                case 'signOut':
                    updateUser(null);
                    deleteCognitoCookies();
                    document.location.hash = 'logout';
                    updateFormState((prev) => {
                        const newState = { ...prev, formType: 'signIn', relog: 1, user: null };
                        return newState;
                    });
                    $('.thx').show();
                    break;
                default:
                    break;
            }
        });
    }
    function createUserOnSignUpPage(cognitoID, data) {
        var post_data = {
            "function": 'createNewUserOnSignUpPage',
            "cognitoID": cognitoID,
            "userData": data
        };
        axios.post(callCustomerBackend, post_data)
            .then(result => {
                //console.log(result.data)
            })
            .catch(error => console.log('error:' + error));
    }
    function createUser(data) {
        var post_data = {
            "function": 'createNewUser',
            "authToken": data
        };
        axios.post(callCustomerBackend, post_data)
            .then(result => {
                //console.log(result.data)
            })
            .catch(error => console.log('error:' + error));
    }
    async function checkUser() {
        const now = new Date().toLocaleString('fi-FI', { timeZone: 'Europe/Helsinki' });

        // Skip if in MFA flow with valid user
        if (formState.formType === 'mfaVerification' && formState.user) {
            console.log(`[${now}] [checkUser] Skipping: Already in MFA flow with user`, formState.user.username);
            return;
        }

        try {
            const userToken = await Auth.currentAuthenticatedUser();
            console.log(`[${now}] [checkUser] User found:`, userToken.username);

            if (queryParameters.get('function') !== null) {
                switch (queryParameters.get('function')) {
                    case 'return':
                        props.backToShop();
                        break;
                    case 'info':
                        navigate('/myEkukka' + props.urlParams + '&ref=shop');
                        break;
                    case 'logout':
                        Auth.signOut();
                        updateUser(null);
                        deleteCognitoCookies();
                        backToShop();
                        break;
                    case 'relog':
                        deleteCognitoCookies();
                        updateUser(userToken);
                        props.backToShop();
                        break;
                    default:
                        window.location.href = 'https://' + window.location.hostname + '/profile' + props.urlParams;
                }
            } else {
                if (document.location.hash !== '#logout') {
                    updateUser(userToken);
                    updateFormState((prev) => {
                        const newState = { ...prev, formType: 'signedIn' };
                        console.log(`[${now}] [checkUser] FormState updated:`, newState);
                        return newState;
                    });
                    window.location.href = 'https://' + window.location.hostname + '/profile' + props.urlParams;
                }
            }
        } catch (err) {
            console.error(`[${now}] [checkUser] Error:`, err);
            if (err === 'The user is not authenticated' && document.location.hash === '#relog') {
                $('.login-error-informer').html('Kirjautumisesi on vanhentunut. Kirjaudu uudelleen.').show();
                updateFormState((prev) => ({ ...prev, formType: 'signIn', user: null }));
            }
        }
    }
    function checkPage() {
        const now = new Date().toLocaleString('fi-FI', { timeZone: 'Europe/Helsinki' });

        // Skip if already in mfaVerification with a valid user
        if (formState.formType === 'mfaVerification' && formState.user) {
            return;
        }

        if (queryParameters.get('function') === 'info') {
            window.location.href = 'https://' + window.location.hostname + '/myEkukka' + props.urlParams + '&ref=shop';
            return;
        }
        if (queryParameters.get('function') === 'signup') {
            document.location.hash = 'signUp';
            updateFormState((prev) => {
                const newState = { ...prev, formType: 'signUp', user: prev.user };
                return newState;
            });
            return;
        }
        const page = document.location.hash.substring(1);
        const allowedPages = [
            'userAgreement',
            'myeKukka',
            'signUpValidation',
            'logout',
            'signUp',
            'signIn',
            'signedIn',
            'lostPassword',
            'lostPasswordReset',
            'relog',
            'mfaVerification',
        ];
        if (page && allowedPages.includes(page)) {
            if (page === 'logout') {
                Auth.signOut();
                document.location.hash = 'logout';
                updateFormState((prev) => {
                    const newState = { ...prev, formType: 'signIn', user: null };
                    return newState;
                });
                $('.thx').show();
                return;
            }
            if (page === 'relog') {
                document.location.hash = 'relog';
                checkUser();
                return;
            }
            if (page === 'signUpValidation') {
                if (username_email) {
                    updateFormState((prev) => {
                        const newState = { ...prev, formType: 'signUpValidation', user: prev.user };
                        return newState;
                    });
                    return;
                } else {
                    updateFormState((prev) => {
                        const newState = { ...prev, formType: 'signIn', user: prev.user };
                        return newState;
                    });
                }
            }
            updateFormState((prev) => {
                const newState = { ...prev, formType: page, user: prev.user };
                return newState;
            });
        }
    }
    function onChange(e) {
        e.persist()
        updateFormState(() => ({ ...formState, [e.target.name]: e.target.value }))
    }
    const { formType } = formState


    /* Start: Form validation */
    const { register, handleSubmit, formState: { errors } } = useForm();

    const { register: registerSignup, reset: registerReset, handleSubmit: handleSubmitSignup, watch, setValue, getValues: getValuesSignup, formState: { errors: errorsSignup } } = useForm();
    const { register: registerForgotPassword, handleSubmit: handleSubmitForgotPassword, formState: { errors: errorsForgotPassword } } = useForm();
    const { register: registerLostPasswordReset, handleSubmit: handleSubmitLostPasswordReset, getValues: getValuesLostPasswordReset, formState: { errors: errorsLostPasswordReset } } = useForm();
    const { register: registerSignUpValidation, handleSubmit: handleSubmitSignUpValidation, formState: { errors: errorsSignUpValidation } } = useForm();
    const { register: registerMfa, handleSubmit: handleSubmitMfa, formState: { errors: errorsMfa } } = useForm();

    // CHECK FORM ERRORS
    //console.log(errors, errorsSignup, errorsForgotPassword, errorsLostPasswordReset, errorsSignUpValidation );

    useFormPersist("myeKukka_signUp", {
        watch,
        setValue,
        storage: window.localStorage,
        exclude: ['password', 'password_check']
    });

    const handle_signIn_submit = (data) => {
        //console.log(data)
        signIn(data)
    }
    const handle_signUp_submit = (data) => {
        //console.log(data)
        signUp(data)
    }


    const handle_lostPassword_submit = (data) => {
        //console.log(data)
        lostPassword(data)
    }
    const handle_LostPasswordReset_submit = (data) => {
        //console.log(data)
        lostPasswordResetButton(data)
    }
    const handle_SignUpValidation_submit = (data) => {
        //console.log(data)
        signUpValidation(data)
    }

    /* End: Form validation */

    async function signUp(data) {
        const { username, given_name, family_name, accept_terms_button, accept_marketing_button, order_newsletter_button, password } = data
        if (({ given_name } == null) || ({ given_name } === '') || ({ family_name } == null) || ({ family_name } === '')) {
            $('.signUp_general_error_informer').html('Nimi / sukunimi ei voi olla tyhjä').show();
            return;
        }
        if (!accept_terms_button) {
            $('.signUp_general_error_informer').html('Hyväksy palvelun käyttöehdot').show();
            return;
        }

        if (accept_marketing_button) {
            data.targetedMarketing = 1;
        }
        if (order_newsletter_button) {
            data.newsLetterSubscription = 1;
        }
        //console.log(data)
        try {
            var name = given_name + " " + family_name;
            const signUpData = await Auth.signUp({ username, password, attributes: { family_name, given_name, name } })
            var userCognitoID = signUpData.userSub;

            // create new user in DB
            createUserOnSignUpPage(userCognitoID, data);

            registerReset()

            //username_email = username;
            window.localStorage.setItem('new_username_email', username);
            setUsername_email(window.localStorage.getItem('new_username_email'));

            //console.log(username)
            updateFormState(() => ({ ...formState, formType: "signUpValidation" }))
            document.location.hash = 'signUpValidation';
        }

        catch (e) {
            const findTerm = (term) => {
                if (e.toString().includes(term)) {
                    return true;
                }
                else { return false }
            };
            console.log('errormsg : ', e)
            if (findTerm('Password did not conform with policy: Password not long enough')) {
                $('.signUp_general_error_informer').html('Salasanassa pitää olla:<br/>vähintään 8 kirjainta<br/>1 iso kirjain<br/>1 pieni kirjain<br/>1 numero <br/>1 välimerkki').show();
            }
            else if (findTerm('Username cannot be empty')) {
                $('.signUp_general_error_informer').html('Sähköpostiosoite ei voi olla tyhjä.').show();
            }
            else if (findTerm('Password cannot be empty')) {
                $('.signUp_general_error_informer').html('Salasana ei voi olla tyhjä.').show();
            }
            else if (findTerm('An account with the given email already exists.')) {
                $('.signUp_general_error_informer').html('Jäsenyys on jo luotu tälle sähköpostiosoitteelle.').show();
            }
        }
    }
    const accept_terms_button = registerSignup('accept_terms_button');
    const handleSignUpErrorClear = () => {
        if ($(".accept_terms_button").is(':checked')) {
            $(".signUp_general_error_informer").hide()
        }
    }


    const handleMfaSubmit = async (data) => {
        const now = new Date().toLocaleString('fi-FI', { timeZone: 'Europe/Helsinki' });

        try {
            if (!formState.user) {
                console.error(`[${now}] [handleMfaSubmit] No user in formState. Redirecting to signIn...`);
                updateFormState(() => ({ ...formState, formType: 'signIn', user: null }));
                document.location.hash = 'signIn';
                $('.general_error_informer').html('Istunto vanhentunut. Kirjaudu uudelleen.').show();
                return;
            }

            const updatedUser = await Auth.confirmSignIn(formState.user, data.mfaCode, 'SOFTWARE_TOKEN_MFA');
            console.log(`[${now}] [handleMfaSubmit] MFA Success! Updated User:`, updatedUser);

            
            // Update formState with the authenticated user
            updateFormState((prev) => {
                const newState = { ...prev, user: updatedUser };
                console.log(`[${now}] [handleMfaSubmit] FormState updated:`, newState);
                return newState;
            });

            Hub.dispatch('auth', { event: 'signIn', data: updatedUser });
        } catch (err) {
            console.error(`[${now}] [handleMfaSubmit] MFA Error:`, err);
            let errorMsg = 'Virheellinen MFA-koodi. Yritä uudelleen.';
            if (err.code === 'CodeMismatchException') {
                errorMsg = 'Väärä MFA-koodi. Tarkista koodi ja yritä uudelleen.';
            } else if (err.code === 'NotAuthorizedException' || err.message === 'The user is not authenticated') {
                errorMsg = 'Istunto vanhentunut. Kirjaudu uudelleen.';
                updateFormState(() => ({ ...formState, formType: 'signIn', user: null }));
                document.location.hash = 'signIn';
            } else if (err.name === 'TypeError') {
                errorMsg = 'Käyttäjätietoja ei saatu. Kirjaudu uudelleen.';
                updateFormState(() => ({ ...formState, formType: 'signIn', user: null }));
                document.location.hash = 'signIn';
            }
            $('.general_error_informer').html(errorMsg).show();
        }
    };

    async function signIn(data) {
        const now = new Date().toLocaleString('fi-FI', { timeZone: 'Europe/Helsinki' });
        console.log(`[${now}] [signIn] Starting with:`, data.username);

        deleteCognitoCookies();

        $('.thx').hide();
        if ($('.thx').text() === 'Kiitos jäsenyydestäsi') {
            $('.thx').show();
        }

        try {
            
            const user = await Auth.signIn(data.username, data.password);
			/*
            console.log(`[${now}] [signIn] Sign-in response:`, {
                username: user.username,
                challengeName: user.challengeName,
                session: user.Session,
            });
			*/

            if (user.challengeName === 'SOFTWARE_TOKEN_MFA') {
                updateFormState((prev) => {
                    const newState = {
                        ...prev,
                        formType: 'mfaVerification',
                        user,
                    };
                    return newState;
                });
                document.location.hash = 'mfaVerification';
                return;
            }

            Hub.dispatch('auth', { event: 'signIn', data: user });
        } catch (e) {
            console.error(`[${now}] [signIn] Error:`, e);
            switch (e.message) {
                case 'Username should be either an email or a phone number.':
                    $('.general_error_informer').html('Käyttäjätunnus tulee olla sähköpostiosoite.').show();
                    $('#sign_in_email').html('Käyttäjätunnus tulee olla sähköpostiosoite.').show();
                    break;
                case 'User is not confirmed.':
                    updateFormState(() => ({ ...formState, formType: 'signUpValidation' }));
                    document.location.hash = 'signUpValidation';
                    break;
                case 'Incorrect username or password.':
                    $('.general_error_informer').html('Käyttäjätunnus tai salasana on väärin.').show();
                    break;
                case 'User does not exist.':
                    $('.general_error_informer').html('Käyttäjätunnusta ei ole olemassa.').show();
                    break;
                case 'Username cannot be empty':
                    $('#sign_in_email').html('Käyttäjätunnus ei voi olla tyhjä.').show();
                    break;
                case 'Failed to get the signed in user No current user':
                    $('.general_error_informer').html('Kirjautunutta käyttäjää ei voitu muuttaa ei kirjautuneeksi.').show();
                    break;
                default:
                    $('.general_error_informer').html(e.message).show();
            }
        }
    }

    function deleteCognitoCookies() {
        const now = new Date().toLocaleString('fi-FI', { timeZone: 'Europe/Helsinki' });
        $.each(document.cookie.split(/; */), function () {
            const splitCookie = this.split('=');
            const cookieName = splitCookie[0];
            if (
                cookieName.startsWith('CognitoIdentityServiceProvider.') &&
                !cookieName.includes('LastAuthUser') &&
                !cookieName.includes('idToken') &&
                !cookieName.includes('accessToken')
            ) {
                const derivedDomain = 'ekukka.fi' || document.domain;
                const derivedPath = '' || '/';
                document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${derivedDomain}; path=${derivedPath}`;
            
            }
        });
    }


    async function signUpValidation(data) {
        const { authCode } = data //formState
        try {
            await Auth.confirmSignUp(username_email, authCode);
            updateFormState(() => ({ ...formState, formType: "signIn" }))
            document.location.hash = 'signIn';
            $('.thx').text("Vahvistuskoodi hyväksytty").show()
        }
        catch (e) {
            switch (e.message) {
                case 'Invalid verification code provided, please try again.':
                    $('#signupValidation_authCode').html('Virheellinen vahvistuskoodi, yritä uudelleen.').show();
                    break;
                case 'Attempt limit exceeded, please try after some time.':
                    $('.general_error_informer').html('Yritysraja ylitetty, yritä jonkin ajan kuluttua.').show();
                    break;
                case 'User cannot be confirmed. Current status is CONFIRMED':
                    $('.general_error_informer').html('Käyttäjää ei voida vahvistaa. Käyttäjä on jo vahvistettu.').show();
                    break;
                default:
                    $('.general_error_informer').html(e.message).show();
            }
        }
    }
    async function resendValidation() {
        try {
            await Auth.resendSignUp(username_email);
            $('.resend_email').addClass('disabled').html('Lähetetään').css("color", "white")
            setTimeout(function () { $('.resend_email').addClass('disabled').html('Lähetä').css("color", "white") }, 1000);
        } catch (err) {
            console.log('error resending code: ', err);
            $('.signUpValidaton-error-informer').html('Tarkista koodi').show();
        }
    }

    async function lostPassword(data) {
        const { lost_password_username } = data
        setUser_lost_password_email(lost_password_username)
        try {
            await Auth.forgotPassword(lost_password_username)
            updateFormState(() => ({ ...formState, formType: "lostPasswordReset" }))
            document.location.hash = 'lostPasswordReset';
        } catch (err) {
            console.log(err)
            switch (err.message) {
                case 'Username/client id combination not found.':
                    $('.general_error_informer').html('Jäsenyyttä ei löytynyt.').show();
                    break;
                default:
                    $('.general_error_informer').html(err.message).show();
            }
        }
    }

    async function lostPasswordResetButton(data) {
        const { authCode, new_password } = data
        try {
            await Auth.forgotPasswordSubmit(user_lostpassword_email, authCode, new_password)
            updateFormState(() => ({ ...formState, formType: "signIn" }))
            document.location.hash = 'signIn';
        } catch (err) {
            console.log(err)
            switch (err.message) {
                case 'Attempt limit exceeded, please try after some time.':
                    $('.general_error_informer').html('Yritysraja ylitetty, yritä jonkin ajan kuluttua.').show();
                    break;
                case 'Invalid verification code provided, please try again.':
                    $('#lostPasswordReset_authCode').html('Vahvistuskoodi on virheellinen. Yritä uudelleen.').show();
                    break;
                case 'Password does not conform to policy: Password not long enough':
                    $('.general_error_informer').html('Salasana ei ole tarpeeksi pitkä.').show();
                    break;
                case 'Username/client id combination not found.':
                    $('.general_error_informer').html('Käyttäjää ei löydetty.').show();
                    break;
                default:
                    $('.general_error_informer').html(err.message).show();
            }
        }
    }

    const changeTo = (pageToGo) => {
        updateFormState(() => ({ ...formState, formType: pageToGo }))
        document.location.hash = pageToGo;

    }
    function checkbox_change(target) {
        if ($(target).hasClass('checker')) {
            target = $(target).parent()
        }
        if ($(target).hasClass('checked')) {
            $(target).removeClass('checked')
            $(target).children('.checker').css({ 'display': 'none' })
        }
        else {
            $(target).addClass('checked')
            $(target).children('.checker').css({ 'display': 'block' })

            if ($(target).hasClass('accept_terms_button')) {
                $(".signUp_general_error_informer").hide()
            }
        }
    }
    const ScrollToTheTop = () => {
        window.scrollTo(0, 0)
    }



    return (
        <>
            <Header />

            <div id="content">
                {

                    formType === 'signUp' && (
                        <div className="sign_up_form">

                            <div className="header_container">
                                <div className="go_back_div" onClick={() => changeTo('signIn')}><FontAwesomeIcon className="chevronLeft" icon={faChevronLeft} size="1x" /> <span className="textUnderline">Palaa takaisin</span></div>
                                <div className="omatili_more_info" onClick={() => navigate('/myeKukka')}><span>Tietoa Oma eKukasta</span></div>
                            </div>

                            <div className="signin_topic">Liity Oma eKukkaan</div>
                            <div className="form_wrapper">
                                <form onSubmit={handleSubmitSignup(handle_signUp_submit)}>

                                    <div className="input_container">
                                        <span>Etunimi *</span><input name='given_name' onChange={onChange} className={errorsSignup.given_name ? 'invalid' : ''} {...registerSignup("given_name", { required: true })}></input>
                                        <div id="sign_up_name" className='form_error'>
                                            {errorsSignup.given_name && errorsSignup.given_name?.type === "required" && (
                                                "Etunimi on pakollinen kenttä"
                                            )}
                                        </div>
                                    </div>

                                    <div className="input_container">
                                        <span>Sukunimi *</span><input name='family_name' onChange={onChange} className={errorsSignup.family_name ? 'invalid' : ''} {...registerSignup("family_name", { required: true })}></input>
                                        <div id="sign_up_family_name" className='form_error'>
                                            {errorsSignup.family_name && errorsSignup.family_name?.type === "required" && (
                                                "Sukunimi on pakollinen kenttä"
                                            )}
                                        </div>
                                    </div>

                                    <div className="input_container">
                                        <span>Sähköpostiosoite *</span><input type="email" name='username' onChange={onChange} className={errorsSignup.username ? 'invalid' : ''} {...registerSignup("username", { required: true })}></input>
                                        <div id="sign_up_username" className='form_error'>
                                            {errorsSignup.username && errorsSignup.username?.type === "required" && (
                                                "Sähköpostiosoite on pakollinen kenttä"
                                            )}
                                        </div>
                                    </div>

                                    <div className="input_container">
                                        <span>Salasana *</span><input name='password' type="password" onChange={onChange} className={errorsSignup.password ? 'invalid' : ''} {...registerSignup("password", { required: true })}></input>
                                        <div id="sign_up_password" className='form_error'>
                                            {errorsSignup.password && errorsSignup.password?.type === "required" && (
                                                "Salasana on pakollinen kenttä"
                                            )}
                                        </div>
                                    </div>

                                    <div className="input_container">
                                        <span>Salasana uudelleen *</span><input name='password_check' type="password" onChange={onChange} className={errorsSignup.password_check ? 'invalid' : ''}
                                            {...registerSignup("password_check", {
                                                required: true,
                                                validate: {
                                                    emailEqual: value => (value === getValuesSignup().password)
                                                }
                                            })}
                                        ></input>
                                        <div id="sign_up_password_check" className='form_error'>
                                            {errorsSignup.password_check && errorsSignup.password_check?.type === "required" && (
                                                "Salasana uudelleen on pakollinen kenttä"
                                            )}
                                            {errorsSignup.password_check?.type === "emailEqual" && (
                                                "Salasana ei täsmää"
                                            )}
                                        </div>
                                    </div>


                                    <div className="checkbox_options_container">
                                        <input type="checkbox" className="accept_terms_button checkbox_real"  {...accept_terms_button}
                                            onChange={e => {
                                                accept_terms_button.onChange(e);
                                                handleSignUpErrorClear(e);
                                            }}
                                        />
                                        <span className="checkbox_span"> Hyväksyn palvelun <span className="checkbox_span link_texts" onClick={() => navigate('/userAgreement')}>käyttöehdot</span>. *</span>
                                    </div>

                                    <div className="checkbox_options_container">
                                        <input type="checkbox" className="accept_marketing_button checkbox_real" {...registerSignup("accept_marketing_button")} />
                                        <span className="checkbox_span"> Annan suostumuksen kohdennetulle markkinoinnille ja asiakasviestinnälle.</span>
                                    </div>

                                    <div className="checkbox_options_container">
                                        <input type="checkbox" className="order_newsletter_button checkbox_real" {...registerSignup("order_newsletter_button")} />
                                        <span className="checkbox_span"> Kyllä, haluan Kukkaystävät-uutiskirjeen sähköpostiini.</span>
                                    </div>



                                    <div className='signUp_general_error_informer'></div>

                                    <div className="signup_button_container">
                                        <button type="submit" className="ekukka-btn ekukka-btn-primary large-btn">Liity</button>
                                    </div>
                                </form>
                            </div>
                            <div className="signup_link_wrapper">
                                Oletko jo jäsen? <span className="sign_link" onClick={() => changeTo('signIn')}>Kirjaudu sisään</span>
                            </div>
                        </div>
                    )
                }
                {

                    formType === 'signIn' && (
                        <div className="signin_form" >
                            {ScrollToTheTop()}
                            <div className="go_back_div" onClick={backToShop}><FontAwesomeIcon className="chevronLeft" icon={faChevronLeft} size="1x" /> <span className="textUnderline">Palaa eKukkaan</span></div>
                            <div className="thx">Kiitos vierailusta!<br />Nähdään uudelleen kukkien parissa!</div>
                            <div className="signin_topic">Kirjaudu sisään Oma eKukkaan</div>



                            <div className="form_wrapper" >
                                <form onSubmit={handleSubmit(handle_signIn_submit)}>

                                    <div className="input_container">
                                        <span>Sähköpostiosoite *</span>
                                        <input type="email" className={errors.username ? 'invalid' : ''} name='username' onChange={onChange} placeholder=''  {...register("username", { required: true })}></input>
                                        <div id="sign_in_email" className='form_error'>
                                            {errors.username && errors.username?.type === "required" && (
                                                "Sähköposti on pakollinen kenttä"
                                            )}
                                        </div>
                                    </div>

                                    <div className="input_container lastFormButtonMb20">
                                        <span>Salasana *</span>
                                        <input name='password' className={errors.username ? 'invalid' : ''} type="password" onChange={onChange} placeholder=''
                                            {...register("password", { required: true })}>
                                        </input>
                                        <div id="sign_in_password" className='form_error'>
                                            {errors.password && errors.password.type === "required" && (
                                                "Salasana on pakollinen kenttä"
                                            )}
                                        </div>
                                    </div>

                                    <div className='general_error_informer'></div>

                                    <div className="login_button_container">
                                        <button className="ekukka-btn ekukka-btn-primary large-btn" type='submit'>Kirjaudu sisään</button>
                                    </div>
                                </form>
                                <div className="lost_password" onClick={() => changeTo('lostPassword')}>Unohditko salasanasi?</div>
                            </div>


                            <div className="separator_container"><div className="separator"></div></div>
                            <div className="login_w_social">
                                <span className="login_w_social_topic">TAI KIRJAUDU SISÄÄN <br /> SEURAAVALLA</span>
                                <div className="login_w_g" onClick={() => Auth.federatedSignIn({ provider: "Google" })}><img className="g_logo" src={googleLogo} alt="G" /><span>Kirjaudu Google-tilillä</span></div>
                                <div className="login_w_fb" onClick={() => Auth.federatedSignIn({ provider: "Facebook" })}><img className="fb_logo" src={fbLogo} alt="FB" /><span>Kirjaudu Facebook-tilillä</span></div>

                            </div>
                            <div className="signup_link_wrapper">
                                Etkö ole vielä jäsen?<span className="sign_link" onClick={() => changeTo('signUp')}>Liity tästä</span>
                            </div>
                        </div>
                    )
                }
                {
                    formType === 'signUpValidation' && (
                        <div className='singUpValidation'>
                            {ScrollToTheTop()}
                            <div className="go_back_div" onClick={() => changeTo('signIn')}><FontAwesomeIcon className="chevronLeft" icon={faChevronLeft} size="1x" /> <span className="textUnderline">Palaa takaisin</span></div>
                            <div className="signin_topic validation_page">Vahvista sähköpostiosoite</div>
                            <span className="first_text">vahvistuskoodi löytyy sähköpostiosoitteestasi:</span>
                            <span className="user_email_address">{username_email}</span>
                            <span className="second_text">Etkö saanut koodia? Lähetä koodi uudelleen.</span>
                            <div className="resend_email" onClick={resendValidation}>Lähetä uudelleen</div>

                            <span className="first_text">Vahvista sähköpostiosoitteesi klikkaamalla sähköpostiin tullutta linkkiä tai vahvista sähköpostiosoite antamalla vahvistuskoodi.</span>



                            <div className="form_wrapper" >
                                <form onSubmit={handleSubmitSignUpValidation(handle_SignUpValidation_submit)}>
                                    <div className="input_container lastFormButtonMb20">
                                        <span className="third_text">Anna vahvistuskoodi *</span>
                                        <input type="number" name="authCode" className={errorsSignUpValidation.authCode ? 'invalid validaton_box' : 'validaton_box'} onChange={onChange} {...registerSignUpValidation("authCode", { required: true })}></input>
                                        <div id="signupValidation_authCode" className='form_error'>
                                            {errorsSignUpValidation.authCode && errorsSignUpValidation.authCode.type === "required" && (
                                                "Vahvistuskoodi on pakollinen kenttä"
                                            )}
                                        </div>
                                    </div>


                                    <div className='general_error_informer'></div>
                                    <div className="button_container">
                                        <button type="submit" className="ekukka-btn ekukka-btn-primary">Valmis</button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    )
                }
                {
                    formType === 'signedIn' && (
                        <div className="loading_form">
                            <div className="centerElement">
                                <div className="loading_header">Ladataan profiilia...</div>
                            </div>
                        </div>
                    )
                }
                {
                    formType === 'lostPassword' && (
                        <div className="lost_password_page">
                            <div className="go_back_div" onClick={() => changeTo('signIn')}><FontAwesomeIcon className="chevronLeft" icon={faChevronLeft} size="1x" /> <span className="textUnderline">Palaa takaisin</span></div>
                            <div className="helptext_for_pw_re">
                                <span className="forgot_pass_topic">Unohditko salasanasi?</span>
                                <span>Ei haittaa. Syötä sähköpostiosoitteesi.</span>
                            </div>
                            <div className="form_wrapper" >
                                <form onSubmit={handleSubmitForgotPassword(handle_lostPassword_submit)}>
                                    <div className="input_container lastFormButtonMb20">
                                        <span>Sähköpostiosoite *</span>
                                        <input type="email" className={errorsForgotPassword.lost_password_username ? 'invalid recovery_email_box' : 'recovery_email_box'} name='lost_password_username' onChange={onChange} {...registerForgotPassword("lost_password_username", { required: true })}></input>
                                        <div id="lostpassword_username" className='form_error'>
                                            {errorsForgotPassword.lost_password_username && errorsForgotPassword.lost_password_username.type === "required" && (
                                                "Sähköpostiosoite on pakollinen kenttä"
                                            )}
                                        </div>
                                    </div>

                                    <div className='general_error_informer'></div>

                                    <div className="login_button_container">
                                        <button className="ekukka-btn ekukka-btn-primary large-btn" type="submit">Lähetä salasana</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )
                }
                {
                    formType === 'lostPasswordReset' && (

                        <div className="lostPasswordReset">
                            <div className="go_back_div" onClick={() => changeTo('lostPassword')}><FontAwesomeIcon className="chevronLeft" icon={faChevronLeft} size="1x" /> <span className="textUnderline">Palaa takaisin</span></div>
                            <div className="helptext_for_pw_re_page">
                                <span className="forgot_pass_topic">Täytä tiedot ja laita uusi salasana.</span>
                                <span>Vahvistuskoodi on lähetetty sähköpostiisi.</span>
                            </div>
                            <div className="form_wrapper">
                                <form onSubmit={handleSubmitLostPasswordReset(handle_LostPasswordReset_submit)}>


                                    <div className="input_container">
                                        <span>Vahvistuskoodi *</span>
                                        <input type="number" name='authCode' className={errorsLostPasswordReset.authCode ? 'invalid' : ''} onChange={onChange}  {...registerLostPasswordReset("authCode", { required: true })}></input>
                                        <div id="lostPasswordReset_authCode" className='form_error'>
                                            {errorsLostPasswordReset.authCode && errorsLostPasswordReset.authCode.type === "required" && (
                                                "Vahvistuskoodi on pakollinen kenttä"
                                            )}
                                        </div>
                                    </div>

                                    <div className="input_container">
                                        <span>Uusi salasana *</span>
                                        <input type="password" name='new_password' className={errorsLostPasswordReset.new_password ? 'invalid' : ''} onChange={onChange}  {...registerLostPasswordReset("new_password", { required: true })}></input>
                                        <div id="lostPasswordReset_new_password" className='form_error'>
                                            {errorsLostPasswordReset.new_password && errorsLostPasswordReset.new_password.type === "required" && (
                                                "Sähköpostiosoite on pakollinen kenttä"
                                            )}
                                        </div>
                                    </div>

                                    <div className="input_container lastFormButtonMb20">
                                        <span>Uusi salasana uudestaan *</span>
                                        <input type="password" name='new_password_2' className={errorsLostPasswordReset.new_password_2 ? 'invalid' : ''} onChange={onChange} {...registerLostPasswordReset("new_password_2", {
                                            required: true,
                                            validate: {
                                                emailEqual: value => (value === getValuesLostPasswordReset().new_password)
                                            }
                                        })}
                                        ></input>
                                        <div id="lostPasswordReset_password_check" className='form_error'>
                                            {errorsLostPasswordReset.new_password_2 && errorsLostPasswordReset.new_password_2?.type === "required" && (
                                                "Salasana uudelleen on pakollinen kenttä"
                                            )}
                                            {errorsLostPasswordReset.new_password_2?.type === "emailEqual" && (
                                                "Salasana ei täsmää"
                                            )}
                                        </div>
                                    </div>

                                    <div className='general_error_informer'></div>
                                    <div className="button_container">
                                        <button type="submit" className="ekukka-btn ekukka-btn-primary">Vaihda salasana</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )
                }

                {
                    formType === 'mfaVerification' && (
                        <div className="mfa_verification">
                            {ScrollToTheTop()}
                            <div className="go_back_div" onClick={() => changeTo('signIn')}>
                                <FontAwesomeIcon className="chevronLeft" icon={faChevronLeft} size="1x" />
                                <span className="textUnderline">Palaa takaisin</span>
                            </div>
                            <div className="signin_topic">Syötä kuusinumeroinen koodi</div>
                            <div className="signin_discription">Avaa todennussovellus, kuten Microsoft Authenticator tai Google Authenticator, ja syötä sovelluksessa näkyvä koodi.</div>
                            <div className="form_wrapper">
                                <form onSubmit={handleSubmitMfa(handleMfaSubmit)}>
                                    <div className="input_container lastFormButtonMb20">
                                        <span style={{fontSize: '16px', fontWeight: '400'}}>Koodi todennussovelluksestasi *</span>
                                        <input
                                            type="text"
                                            className={errorsMfa.mfaCode ? 'invalid' : ''}
                                            {...registerMfa("mfaCode", { required: true })}
                                            placeholder="123456"
                                        />
                                        <div id="mfa_code_error" className="form_error">
                                            {errorsMfa.mfaCode && "MFA-koodi on pakollinen"}
                                        </div>
                                    </div>
                                    <div className="general_error_informer"></div>
                                    <div className="login_button_container">
                                        <button type="submit" className="ekukka-btn ekukka-btn-primary large-btn">
                                            Vahvista
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )
                }
            </div>


            <Footer onChange={value => changeTo(value)} />
        </>
    )
}

export default Login;
